import { TOrderInfoKeyword } from "@/entities/new-order";

export function getKeywordsUniqueKeys(data: TOrderInfoKeyword[]): string[] {
  const values: string[] = [];
  for (let i = 0; i < data.length; i++) {
    const value = data[i].keyword;
    if (!values.includes(value)) {
      values.push(value);
    }
  }
  return values;
}
